// eBay types
// Supported eBay marketplaces
export const EBAY_SITES = [
    { id: 'EBAY_US', name: 'eBay.com (United States)', currency: 'USD', domain: 'ebay.com' },
    { id: 'EBAY_GB', name: 'eBay.co.uk (United Kingdom)', currency: 'GBP', domain: 'ebay.co.uk' },
    { id: 'EBAY_DE', name: 'eBay.de (Germany)', currency: 'EUR', domain: 'ebay.de' },
    { id: 'EBAY_AU', name: 'eBay.com.au (Australia)', currency: 'AUD', domain: 'ebay.com.au' },
    { id: 'EBAY_CA', name: 'eBay.ca (Canada)', currency: 'CAD', domain: 'ebay.ca' },
    { id: 'EBAY_FR', name: 'eBay.fr (France)', currency: 'EUR', domain: 'ebay.fr' },
    { id: 'EBAY_IT', name: 'eBay.it (Italy)', currency: 'EUR', domain: 'ebay.it' },
    { id: 'EBAY_ES', name: 'eBay.es (Spain)', currency: 'EUR', domain: 'ebay.es' },
];
// eBay condition codes
export const EBAY_CONDITIONS = {
    1000: 'New',
    1500: 'Open box',
    3000: 'Used - Like New',
    4000: 'Used - Good',
    5000: 'Used - Acceptable',
    6000: 'For parts or not working',
};
// Listing types
export const EBAY_LISTING_TYPES = ['AUCTION', 'FIXED_PRICE'];
// Listing durations
export const EBAY_DURATIONS = [
    { value: 'DAYS_3', label: '3 days' },
    { value: 'DAYS_5', label: '5 days' },
    { value: 'DAYS_7', label: '7 days' },
    { value: 'DAYS_10', label: '10 days' },
    { value: 'GTC', label: 'Good \'Til Cancelled' },
];
//# sourceMappingURL=ebay.js.map